import { FileProtectOutlined } from '@ant-design/icons-vue';

/** 單層選單：點「保單管理」直接進列表 */
export const policyRoute = {
    path: '/policies/list',
    alias: '/policies',
    component: () => import('@/views/Policy/PolicyList.vue'),
    name: 'Policy.List',
    meta: {
        title: '保單管理',
        icon: FileProtectOutlined,
        permission: [171800]
    }
};
